export default __webpack_public_path__ + "static/media/yplogo.40065bb4.png";